import { TestKitLogType } from "@/common/types";
import { transformKitStatus } from "@/utils/common.util";
import { convertDateToString } from "@/utils/date.util";

const TestLogs: React.FC<{ logs: TestKitLogType }> = ({ logs }) => {
  return (
    <div className="flex flex-col gap-2">
      {Object.keys(logs)
        .filter((key) => key.includes("at"))
        .filter((key) => logs[key as keyof TestKitLogType] !== null)
        .map((key) => (
          <div key={key} className="flex items-center justify-between">
            <p className="font-bold">
              {transformKitStatus(key.replace("_at", ""))}
            </p>
            <p className="text-gray-500 font-normal text-sm">
              {convertDateToString(logs[key as keyof TestKitLogType])}
            </p>
          </div>
        ))}
    </div>
  );
};

export default TestLogs;
